import { action, computed } from 'mobx';

import { RouterStore } from '@estee/elc-router';
import { ViewController } from '@estee/elc-service';

import { ConfigRepository } from '~repositories/ConfigRepository';
import { MessageGroup, MessageRepository } from '~repositories/MessageRepository';
import { UserRepository } from '~repositories/UserRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

interface IResetPasswordFormViewController {
    userRepository: UserRepository;
    configRepository: ConfigRepository;
    routerStore: RouterStore;
}
export class ResetPasswordFormViewController extends ViewController {
    private userRepository: UserRepository;
    private configRepository: ConfigRepository;
    private messageRepository: MessageRepository;
    private routerStore: RouterStore;

    constructor({
        userRepository,
        configRepository,
        routerStore
    }: IResetPasswordFormViewController) {
        super();

        this.userRepository = userRepository;
        this.configRepository = configRepository;
        this.routerStore = routerStore;
        this.messageRepository = diContainer.get(serviceNames.messageRepository);
    }

    @computed
    public get data() {
        const {
            signInWithOtpFormStore,
            signInWithOtpFormStore: {
                values: { emailAddress }
            }
        } = this.userRepository;
        const { passwordFields, passwordValidations } = this.configRepository;

        return {
            errorMessages: this.messageRepository.messages.get(MessageGroup.PASSWORD),
            formStore: signInWithOtpFormStore,
            sendToText: emailAddress,
            passwordValidations,
            schema: passwordFields
        };
    }

    @action
    public savePasswordAndSignInClicked = async () => {
        const {
            signInWithOtpFormStore: {
                values: { emailAddress, password },
                validateForm,
                isValid,
                setSubmitting
            }
        } = this.userRepository;
        const { clearMessagesByGroup } = this.messageRepository;

        clearMessagesByGroup(MessageGroup.PASSWORD);
        validateForm();

        if (isValid) {
            const body = {
                emailAddress,
                password
            };
            setSubmitting(true);
            const { success, transKey } = await this.userRepository.savePasswordAndSignIn(body);

            if (success) {
                const { onSuccessRedirectUrl } = this.configRepository;

                this.routerStore.changeLocation(onSuccessRedirectUrl);
            } else {
                this.messageRepository.setMessages(MessageGroup.PASSWORD, [{ transKey }]);
            }
            setSubmitting(false);
        }
    };
}
